import { create } from 'zustand';

interface ISocketState {
  isConnected: boolean;
}

interface ISocketStateActions {
  setConnected: (connected: boolean) => void;
}

type IStore = ISocketState & ISocketStateActions;

export const useSocketState = create<IStore>(set => ({
  isConnected: false,
  setConnected: (connected: boolean) => set({ isConnected: connected })
}));
